import { render, staticRenderFns } from "./notifications-dashboard.vue?vue&type=template&id=3de26506&scoped=true&"
import script from "./notifications-dashboard.vue?vue&type=script&lang=js&"
export * from "./notifications-dashboard.vue?vue&type=script&lang=js&"
import style0 from "./notifications-dashboard.vue?vue&type=style&index=0&id=3de26506&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de26506",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3de26506')) {
      api.createRecord('3de26506', component.options)
    } else {
      api.reload('3de26506', component.options)
    }
    module.hot.accept("./notifications-dashboard.vue?vue&type=template&id=3de26506&scoped=true&", function () {
      api.rerender('3de26506', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/theme/components/projects/notifications/notifications-dashboard.vue"
export default component.exports